// extracted by mini-css-extract-plugin
export default {"tagCollection":"tagCollectionqrRuk"};